import type { DoorDescriptor } from "building-types/doors/doorTypes";
import { mergeWithDefaultsAndOverrides } from "common/utils/mergeWithDefaultsAndOverrides";

export function doorDescriptorNew(
  opts: Partial<DoorDescriptor> & Pick<DoorDescriptor, "id" | "reportedName">,
): DoorDescriptor {
  if (opts.height === undefined && !opts.requiresHeightComputation) {
    console.assert(false, `${opts.id} - height not provided and requiresHeightComputation is false`);
  }

  return mergeWithDefaultsAndOverrides<DoorDescriptor>(
    {
      zOffset: 0,
      requiresHeightComputation: false,
      arcDepth: 0,
      requiresDoorSwing: true,
      isExterior: false,
      isPrimaryDoor: false,
      doorLeafCount: 1,
      includeTrim: true,
    },
    opts,
    {
      catalogItemType: "DOOR_DESCRIPTOR",
    },
  );
}
